"use strict";

var _defineProperty = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _createForOfIteratorHelper = require("/var/www/prod/lucky1/lucky-one-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _default2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.skipAllButComputedKey = skipAllButComputedKey;

var _t = require("@babel/types");

var VISITOR_KEYS = _t.VISITOR_KEYS,
    staticBlock = _t.staticBlock;

function skipAllButComputedKey(path) {
  if (!path.node.computed) {
    path.skip();
    return;
  }

  var keys = VISITOR_KEYS[path.type];

  var _iterator = _createForOfIteratorHelper(keys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      if (key !== "key") path.skipKey(key);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var skipKey = (staticBlock ? "StaticBlock|" : "") + "ClassPrivateProperty|TypeAnnotation|FunctionDeclaration|FunctionExpression";

var _default = (_default2 = {}, _defineProperty(_default2, skipKey, function (path) {
  return path.skip();
}), _defineProperty(_default2, "Method|ClassProperty", function MethodClassProperty(path) {
  skipAllButComputedKey(path);
}), _default2);

exports.default = _default;